import React, { useState } from 'react';

import ModalContentWrapper from "root/Modals/ModalContentWrapper";

import { setAcceptableUsageAgreed } from "root/DataFunctions/LoginFns";

const ModalAcceptableUsePolicy = (props ) =>
{
    const [ closeAllowed, setCloseAllowed ] = useState ( false ) ;
    const [ buttonState, setButtonState ] = useState ( 'disabled' ) ;
    //setButtonState('') ;

    const doSetUsageTermsAgreed = () =>
    {
        setAcceptableUsageAgreed((response) => {
            props.onClose() ;
        }) ;
    }

    const onClickAgree = () =>
    {
        /*if ( closeAllowed === true )
        {
            doSetUsageTermsAgreed() ;
        }*/

        doSetUsageTermsAgreed() ;
    }

    const onClickDisagree = () =>
    {
        /*if ( closeAllowed === true )
        {
            doSetUsageTermsAgreed() ;
        }*/

        props.onClose('logout') ;
    }

    /*const onScrollBottomReached = () =>
    {
        console.log ("Bottom Reached") ;

        setCloseAllowed(true);
        setButtonState('') ;
    }*/

    const onFocus = ( e ) =>
    {
        e.preventDefault();
        e.target.focus({preventScroll: true});
    }

    return (
        <ModalContentWrapper>
            <div className='privacy-scroller'>
                <h1 style={{textAlign: 'center'}}>ARCBOX Acceptable Use Policy</h1>
                <h2 style={{textAlign: 'center'}}>Welcome to the ARCBOX System</h2>
                <h2 style={{textAlign: 'center'}}>Please read the notice below which defines usage behaviour expected from users of the ARCBOX system.</h2>

                <ul>
                    <li>All users must take responsibility for their own use of ARCBOX, making sure that they use ARCBOX safely, responsibly, and legally.</li>
                    <li>All users must take personal responsibility for their e-safety awareness of the on-line opportunities and risks posed by using ARCBOX.</li>
                    <li>ARCBOX must not be used for the bullying or harassment of others in any form.</li>
                    <li>ARCBOX must not be used to bring others into disrepute.</li>
                    <li>All users have a responsibility to report any known misuses of ARCBOX, including the unacceptable behaviours of others.</li>
                    <li>All users have a duty to respect the technical safeguards, which are in place.
                        Any attempt to breach technical safeguards, conceal network identities, or
                        gain unauthorised access to systems and services, is unacceptable</li>
                    <li>All users have a duty to report failings in technical safeguards, which may become apparent when using ARCBOX.</li>
                    <li>All users have a duty to protect their passwords and personal network logins,
                        and should log off the network when leaving workstations unattended. Any
                        attempts to access, corrupt, or destroy other users’ data, or compromise the
                        privacy of others in any way, using ARCBOX, is unacceptable.</li>
                    <li>All users should understand that system activity is logged for audit purposes.</li>
                    <li>All users should be aware that in certain circumstances where unacceptable use is suspected, enhanced monitoring and procedures may come into action.</li>
                    <li>All users must take responsibility for reading and upholding the standards laid out in the Acceptable Use Policy.</li>
                    <li>Any breach of this policy will result in the suspension of your account.</li>
                    <br></br>
                    <li>To report any unacceptable behaviour please email: <a href="mailto:info@arcbox.co.uk"> info@arcbox.co.uk</a></li>
                </ul>
            </div>

            <div className="row" style={{textAlign: 'center'}}>
                <button  onClick={onClickAgree} style={{ marginLeft: '15px'}} className="btn btn-primary">Agree - proceed to ARCBOX<i className="et-check"/></button>
                <button  onClick={onClickDisagree} style={{ marginLeft: '15px'}} className="btn btn-danger">Disagree - log out of ARCBOX<i className="et-check"/></button>
            </div>

        </ModalContentWrapper>
    )
}

export default ModalAcceptableUsePolicy ;